/* eslint-disable */
import React, { useState } from 'react'
import { useEffect } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import SideBar from './SideBar'
import Swal from 'sweetalert2'
import { PaginationControl } from "react-bootstrap-pagination-control";
import {
  FaCashRegister,
  FaFileMedical,
  FaPenSquare,
  FaRegEdit,
  FaFileExcel,
  FaRegTrashAlt
} from 'react-icons/fa'
import apiInstance from '../../utils/api'
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
const LabServiceList = () => {
  const [open, setOpen] = useState(false)
  const [close, setClose] = useState(false)
  const [doctorLists, setDoctorLists] = useState([])
  const [filteredList, setFilteredList] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = React.useState("");
  const [dataCount, setDataCount] = useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const paginationItems = React.useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return filteredList?.slice(start, end);
  }, [page, filteredList]);
  // console.log(paginationItems, 'pag')


  const handleDelete = event => {

    apiInstance
      .delete(
        'doctor/' +
        event
      )
      .then(response => {
        Swal.fire({
          title: 'Success',
          text: 'Successfully Deleted!',
          icon: 'success',
          showConfirmButton: false,
          timer: 4000
        })
        const result = doctorLists.filter(item => item._id !== event)
        setFilteredList(result)
      })
      .catch(error => {
        Swal.fire({
          title: 'Error',
          text: error.response.data.message,
          icon: 'error',
          showConfirmButton: false,
          timer: 4000
        })
      })
  }

  const handleSearch = (value) => {

    const searchValue = value.toLowerCase()
    const searchData = doctorLists.filter(test => test.name.toLowerCase().includes(searchValue))
    setFilteredList(searchData)
    setDataCount(
      searchData.length
    );
    setPages(
      searchData.length %
        rowsPerPage ===
        0
        ? searchData.length /
        rowsPerPage
        : Math.floor(
          searchData.length /
          rowsPerPage
        ) + 1
    );
  }

  const showDialog = () => setOpen(true)
  const _export = React.useRef(null)
  const excelExport = () => {
    if (_export.current !== null) {
      console.log(_export.current.props.data)
      _export.current.props.data.map(function (element, index) {
        // element.date = element.date.split('T')[0]
      })
      _export.current.save()
    }
  }
  useEffect(() => {
    const getDoctorLists = async () => {
      const res = await apiInstance.get(
        'doctors?limit=30'
      )

      setDoctorLists(res.data.data)
      setFilteredList(res.data.data)
      setDataCount(
        res.data.data.length
      );
      setPages(
        res.data.data.length %
          rowsPerPage ===
          0
          ? res.data.data.length /
          rowsPerPage
          : Math.floor(
            res.data.data.length /
            rowsPerPage
          ) + 1
      );
    }
    getDoctorLists()
  }, [])
  return (
    <div classNameName='App'>
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className='wrapper'>
        <SideBar />
        {/* <!-- Content Wrapper. Contains page content --> */}

        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item'>
                      <a href='/lab-test'>Home</a>
                    </li>
                    <li className='breadcrumb-item active'>
                      Doctor-Clinic List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className='content'>
            <div className='container-fluid'>


              <div className='row mt-3'>
                <div className='col-12'>
                  <div class='card'>
                    <div class='card-header'>
                      <div class='row d-flex justify-content-between py-3'>

                        <div className=' col-4 ' >
                          <input
                            type='search'
                            className='form-control rounded'
                            id='search_code'
                            placeholder='Enter Account Code'
                            onChange={(e) => handleSearch(e.target.value)}
                          />
                          &nbsp;

                        </div>

                        <div class='offset-4 col-3 float-right '>
                          <Link to='/doctorClinicReg' className='regbtn'>

                            <i class='fas fa-plus'></i> &nbsp;
                            Register
                          </Link>
                          &nbsp;

                          <button
                            type='button'
                            className='btn btn-md btn-success mb-2'
                            onClick={excelExport}
                          >
                            <FaFileExcel />
                            &nbsp;Export
                          </button>
                        </div>

                      </div>

                    </div>

                    <div class='card-body'>
                      {/* Export data in Excel */}
                      <ExcelExport data={paginationItems} ref={_export}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="name"
                          title="Name"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />

                        <ExcelExportColumn
                          field="selection"
                          title="Selection"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="education"
                          title="Education"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="position"
                          title="Position"
                          width={150}
                        />
                        <ExcelExportColumn
                          field="remark"
                          title="Remark"
                          width={150}
                        />
                      </ExcelExport>
                      {/* Export Data in Excel end */}
                      <div class='row'>
                        <div class='col-md-12'>
                          <div
                            class='table-responsive text-black'
                            id='slimtest2'
                          >
                            <table class='table table-hover' id='filter_date'>
                              <thead class=' text-white'>
                                <tr>
                                  <th>#</th>

                                  {/* <th>Bank / Cash Account</th>  */}
                                  <th>Name</th>

                                  <th>Selection</th>

                                  <th>Education</th>
                                  <th>Position</th>
                                  <th className='text-center'>Action</th>
                                </tr>
                              </thead>

                              {paginationItems[0] ? paginationItems.map((doctor, i) => (
                                <tbody className=''>
                                  <tr>
                                    <td>{(page - 1) * rowsPerPage + i + 1}</td>

                                    <td>{doctor.name ? doctor.name : ''}</td>

                                    <td>
                                      {doctor.selection ? doctor.selection : ''}
                                    </td>
                                    <td>
                                      {doctor.education ? doctor.education : ''}
                                    </td>
                                    <td>
                                      {doctor.position ? doctor.position : ''}
                                    </td>

                                    <td className='text-center '>
                                      <button className='btn btn-sm'>
                                        <Link
                                          to={'/refDoctor/' + doctor._id}
                                          className='btn btn-sm btn-primary '
                                        >
                                          Commission
                                        </Link>
                                      </button>
                                      &nbsp;
                                      <Link
                                        to={'/doctorUpdate/' + doctor._id}
                                        className='btn bt-sm btn-warning text-light'
                                      >
                                        <FaRegEdit />
                                      </Link>
                                      &nbsp;
                                      <button
                                        className='btn bt-sm btn-danger'
                                        onClick={e => handleDelete(doctor._id)}
                                      >
                                        <FaRegTrashAlt />
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              )) : (
                                <div className='py-3 d-flex justify-content-center'>

                                  {/* <img src={SearchIcon} width='70px' /> */}
                                  <span className='text-md'>Loading . . .</span>

                                </div>
                              )}
                            </table>
                          </div>
                          <div className='mt-4'>
                            <PaginationControl
                              page={page}
                              between={4}
                              total={dataCount}
                              limit={50}
                              changePage={(page) => {
                                setPage(page);
                              }}
                              ellipsis={1}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <ExpenseDialog
                open={open}
                close={() => setOpen(false)}
                expenseLists={expenseLists}
                setExpenseLists={setExpenseLists}
              /> */}
            </div>
            {/*<!-- /.container-fluid --> */}
          </section>
        </div>
      </div>

      {/* <!-- /.content-wrapper --> */}
      <footer className='main-footer'>
        <strong>
          Copyright &copy; 2017-2020{' '}
          <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside classNameName='control-sidebar control-sidebar-dark'>
        {/* <!-- Control sidebar content goes here --> */}
      </aside>
      {/* <!-- /.control-sidebar --> */}

      {/* <!-- ./wrapper --> */}
    </div>
  )
}
export default LabServiceList
